import { tokens } from "../../tokens";
import { Pressable, type PressableProps } from "../pressable";
import { forwardRef } from "react";
import { Platform, StyleSheet, View } from "react-native";

export type ListItemButtonProps = PressableProps;
export const ListItemButton = forwardRef<View, ListItemButtonProps>(function ListItem(
  props: PressableProps,
  forwardedRef,
) {
  return <Pressable ref={forwardedRef} {...props} style={[styles.listItemButton, props.style]} />;
});

const styles = StyleSheet.create({
  listItemButton: {
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
    ...Platform.select({ web: { cursor: "pointer" } }),
  },
});
